import React from "react";
import Header from "./header/Header";
import PageFooter from "./PageFooter";
import BottomNavbar from "./BottomNavbar";
import { FaDiscord, HiCursorClick } from "./icons/sharedIcons";
import { usePathname } from "next/navigation";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import PlanEndingBanner from "./cancel/PlanEndingBanner";
import { useAuth } from "../context/AuthProvider";

// ReturnBar and CardWall show nothing without a signed-in user, but a static
// import put the whole paywall (UpgradeModal, pricing, Stripe Elements, the
// sign-in form with Formik and yup) on every page for everyone. They are only
// fetched once someone is signed in.
const ReturnBar = dynamic(() => import("./upsell/ReturnBar"), { ssr: false });
const CardWall = dynamic(() => import("./upsell/CardWall"), { ssr: false });

// The card wall's preview (?card_wall_preview=1, then the rest of the tab).
// Kept here rather than imported from CardWall so the wall's code is only
// fetched when it's wanted.
const cardWallPreviewRequested = () => {
  if (typeof window === "undefined") return false;
  try {
    const q = new URLSearchParams(window.location.search).get(
      "card_wall_preview",
    );
    if (q) return q === "1";
    return sessionStorage.getItem("jammable:card-wall:preview") === "1";
  } catch {
    return false;
  }
};

const Layout = ({ children }) => {
  const isBannerShown = false;
  const pathname = usePathname();
  const { user } = useAuth();
  // The card wall's preview (?card_wall_preview=1) also shows signed out on a
  // local `next dev`; CardWall decides who may see it.
  useRouter(); // re-render on navigation, so the preview flag is re-read
  const cardWallPreview = cardWallPreviewRequested();

  return (
    <>
      {/* display: contents, so this wrapper has no box of its own: the
          header's position: sticky then spans the whole page instead of
          being trapped in an 80px-tall parent. */}
      <div className="tw-contents">
        {isBannerShown && pathname !== "/app" && (
          <div
            role="button"
            tabIndex="0" // Make the div focusable
            // onKeyDown={handleKeyPress}
            onClick={() => {
              window.open("https://app.jammable.com", "_blank");
            }}
            style={{
              backgroundColor: "#7289da",
            }}
            className="tw-w-full tw-font-bold tw-text-white tw-h-6 tw-cursor-pointer  tw-flex tw-items-center tw-justify-center tw-fixed tw-top-0 t tw-z-[100] tw-uppercase tw-text-sm"
          >
            <FaDiscord size={18} style={{ marginRight: 4 }} />
            Mashup App IOS Beta Discord
            <HiCursorClick size={18} style={{ marginLeft: 4 }} />
          </div>
        )}
        {pathname !== "/app" && !pathname.includes("/post") && (
          <>
            {/* Above the header: the card wall's strip runs the full width
                of the top of the page (its sheet is fixed, so placement
                doesn't affect it). */}
            {(user?.firebaseUid || cardWallPreview) && <CardWall />}
            <Header isBannerShown={isBannerShown} />
            <BottomNavbar />
            <PlanEndingBanner />
            {user?.firebaseUid && <ReturnBar />}
          </>
        )}
      </div>
      <main className="tw-w-full   tw-scrollbar-thumb-gray-200  tw-scrollbar-thumb-rounded-xl  tw-scrollbar-track-gray-100 tw-scrollbar-thin tw-scrollbar-track-transparent">
        {children}
      </main>
      <PageFooter />
    </>
  );
};

export default Layout;
